import { ExamObservationModel, IExamObservationModel, AssessmentReferralModel, IAssessmentReferralModel, IModel, Model, ModelRecord, IBusinessLineModel, BusinessLineModel, ISpeciesModel, SpeciesModel } from "@common/models"

export interface IExamCategoryModel extends IModel {
    examCategoryId: number
    name: string
    sortOrder: number
    observations: IExamObservationModel[]
    assessmentReferralId: number | undefined;
    assessmentReferral: IAssessmentReferralModel | undefined;
    businessLineId: number;
    businessLine: IBusinessLineModel;
    species: ISpeciesModel[];
}

export class ExamCategoryModel extends Model implements ModelRecord<IExamCategoryModel> {
    examCategoryId: number;
    name: string;
    sortOrder: number;
    observations: ExamObservationModel[] = [];
    assessmentReferralId: number | undefined;
    assessmentReferral: AssessmentReferralModel | undefined;
    businessLineId: number;
    businessLine: BusinessLineModel;
    species: SpeciesModel[] = [];

    constructor(params?: Partial<IExamCategoryModel>) {
        super(params);
        this.examCategoryId = _.defaultTo(params?.examCategoryId, 0);
        this.name = _.defaultTo(params?.name, '');
        this.sortOrder = _.defaultTo(params?.sortOrder, 999);
        _.map(params?.observations, (o) => { this.observations.push(new ExamObservationModel(o)) });
        this.assessmentReferralId = _.defaultTo(params?.assessmentReferralId, undefined);
        this.assessmentReferral = params?.assessmentReferral ? new AssessmentReferralModel(params.assessmentReferral) : undefined;
        this.businessLineId = _.defaultTo(params?.businessLineId, 1);//default to Global
        this.businessLine = params?.businessLine ? new BusinessLineModel(params.businessLine) : new BusinessLineModel({ businessLineId: 1, name: "Global" });
        _.map(params?.species, (s) => { this.species.push(new SpeciesModel(s)) });
        
    }

}
